import { Controller } from '@hotwired/stimulus'

// Hero demo video: autoplays muted in the background (browsers require muted
// autoplay). The overlay play button restarts it from the beginning with sound
// and hands playback over to the browser's native video controls.
export default class extends Controller {
    static targets = ['video', 'overlay']

    connect() {
        if (this.videoTarget.paused) {
            this.videoTarget.play().catch(() => {})
        }
    }

    startWithSound() {
        const video = this.videoTarget
        video.muted = false
        video.currentTime = 0
        video.controls = true
        video.play().catch(() => {})
        this.overlayTarget.classList.add('d-none')
    }
}
